import { render, staticRenderFns } from "./AcceptLoginPhone.vue?vue&type=template&id=faf70bf4&"
import script from "./AcceptLoginPhone.vue?vue&type=script&lang=js&"
export * from "./AcceptLoginPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports